import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class BalanceLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getBalanceLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.balanceLimit,
			"v1/currentcustomerlimits/balancelimit"
		);
	}
}
